import { AssessmentInvoiceSnippet, PaymentsLog, PAYMENTS_LOG } from '@hb/shared'
import { useMemo } from 'react'
import { useDocument } from '../../../../hooks'
import { getPaymentInvoiceSnippets } from './utils'

export const usePaymentColors = ({
  paymentComplete,
  amountPaid,
}: {
  paymentComplete: boolean
  amountPaid?: number
}) => {
  const colorScheme = useMemo(() => {
    if (paymentComplete) return 'green'
    if (amountPaid) return 'orange'
    return 'gray'
  }, [paymentComplete, amountPaid])
  const color = useMemo(() => {
    if (paymentComplete) return 'green.600'
    if (amountPaid) return 'orange.600'
    return 'gray.500'
  }, [paymentComplete, amountPaid])
  return { color, colorScheme }
}

export const usePaymentInvoiceSnippets = (
  assessmentInvoiceSnippets: Record<string, AssessmentInvoiceSnippet>,
  paymentId: string,
) => {
  const paymentInvoiceSnippets = useMemo(
    () => getPaymentInvoiceSnippets(assessmentInvoiceSnippets, paymentId),
    [assessmentInvoiceSnippets, paymentId],
  )

  return paymentInvoiceSnippets
}

// payments log uri example: assessments:[assessmentId]
export const usePaymentsLog = (assessmentId: string | null | undefined) =>
  useDocument<PaymentsLog>(PAYMENTS_LOG, assessmentId)
